// import React from "react";
// import { assets } from "../assets/assets";
// import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

// const ExCollection = () => {
//   const navigate = useNavigate(); // Initialize the useNavigate hook
//   const images = [assets.of1, assets.of2, assets.of3, assets.of4];

//   const handleImageClick = () => {
//     navigate("/collection"); // Redirect to /collection page on click
//   };

//   return (
//     <div className="grid grid-cols-2 md:grid-cols-4 gap-0 m-0">
//       {images.map((imgUrl, index) => (
//         <div key={index} className="relative flex justify-center">
//           <img
//             importance="high"
//             src={imgUrl}
//             alt={`Image ${index + 1}`}
//             className="w-full h-[350px] sm:h-[400px] md:h-[450px] lg:h-[500px] object-cover" // Adjusted height for better fit and responsiveness
//             loading="lazy"
//             onClick={handleImageClick} // Add onClick event handler
//             style={{ cursor: "pointer" }} // Make the image clickable
//           />
//         </div>
//       ))}
//     </div>
//   );
// };

// export default ExCollection;


import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

const ExCollection = () => {
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const images = [
    "https://res.cloudinary.com/dypkxqirq/image/upload/v1757070421/NEW_WEB_SITE_BANNER-01_mjxgao.webp",
    "https://res.cloudinary.com/dypkxqirq/image/upload/v1757070421/NEW_WEB_SITE_BANNER-02_nvpgqr.webp",
    "https://res.cloudinary.com/dypkxqirq/image/upload/v1757070421/NEW_WEB_SITE_BANNER-03_htmjgr.webp",
    "https://res.cloudinary.com/dypkxqirq/image/upload/v1757070421/NEW_WEB_SITE_BANNER-04_evgv0a.webp"
  ];

  const handleImageClick = () => {
    navigate("/collection"); // Redirect to /collection page on click
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-0 m-0">
      {images.map((imgUrl, index) => (
        <div key={index} className="relative flex justify-center">
          <img
            importance="high"
            src={imgUrl}
            alt={`Image ${index + 1}`}
            className="w-full h-[350px] sm:h-[400px] md:h-[450px] lg:h-[500px] object-cover"
            loading="lazy"
            onClick={handleImageClick}
            style={{ cursor: "pointer" }}
          />
        </div>
      ))}
    </div>
  );
};

export default ExCollection;
